exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fs5-estimated-earns .fs5-earnings-forecast-header .fs5-earnings-forecast-tooltip .tooltip .tooltip-inner{font-family:Lato!important;font-size:14px;padding:10px!important;border-radius:4px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e94315b2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/office/js/components/franchise_v5/affiliate_dashboard/estimated_earns/index.vue
// module id = F1D4
// module chunks = 0